<template>
  <div class="mx-3">
    <v-row>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        xl="2"
        lg="3"
        md="12"
        sm="12"
      >
        <v-autocomplete
          v-model="policy"
          :items="jobGroupPolicies"
          item-text="name"
          item-value="id"
          hide-no-data
          hide-selected
          label="Policy Filter"
          placeholder="Choose job group policy"
          @change="loadData"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        xl="2"
        lg="3"
        md="12"
        sm="12"
      >
        <v-autocomplete
          v-model="selectedYear"
          :items="claimCycleYears"
          item-text="name"
          item-value="name"
          hide-no-data
          hide-selected
          label="Year Filter"
          placeholder="Choose year"
          @change="loadData"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        xl="2"
        lg="3"
        md="12"
        sm="12"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in start/end date"
          append-icon="search"
          label="Search"
          hide-no-data
          hide-selected
          autofocus
          clearable 
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="claimCycles"
      :loading="tableLoading"
      :search="search"
    >
      <template v-slot:item.action="{ item }">
        <span
          style="display:inline-block;width:80px"
        >
          <setup-claims-claim-cycle-dialog-delete
            v-if="$hasPermissionTo(['delete claim cycles'])"
            :claim-cycle="item"
            @deleted="loadData"
          />
        </span>
      </template>
    </v-data-table>
    <v-divider class="ml-0 mr-0" />
  </div>
</template>

<script>
  export default {
    components: {
      SetupClaimsClaimCycleDialogDelete: () => import('@/components/hris/setup/claims/claim-cycle/DialogDelete'),
    },
    data () {
      return {
        selectedYear: parseInt(this.$moment().format('YYYY')),
        headers: [
          {
            text: 'Job Group Policy',
            align: 'left',
            sortable: false,
            value: 'job_group_policy.name',
          },
          {
            text: 'Start Date',
            align: 'left',
            sortable: false,
            value: 'start_date',
          },
          {
            text: 'End Date',
            align: 'left',
            sortable: false,
            value: 'end_date',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],  
        policy: 1,
        tableLoading: false,
        claimCycles: [],
        jobGroupPolicies: [],
        claimCycleYears: [],
        search: '',
      }
    },
    created () {
      this.loadClaimCycleYear()
      this.loadJobGroupPolicy()
      this.loadData()
    },
    methods: {
      loadClaimCycleYear () {
        this.$api.claimCycles().listYears()
          .then(res => {
            this.claimCycleYears = res.data
          })
      },
      loadJobGroupPolicy () {
        this.tableLoading = true
        
        this.$api.jobGroupPolicies().list()
          .then(res => {
            this.jobGroupPolicies = res.data.filter(policy => {
              return policy.cutoff_type_id
            })

            this.tableLoading = false
          })
      },
      loadData () {
        this.tableLoading = true

        this.$api.claimCycles().list('?policy=' + this.policy + '&year=' + this.selectedYear)
          .then(res => {
            this.claimCycles = _.orderBy(res.data, ['start_date'], ['desc'])

            this.tableLoading = false
          })
      },
    },
  }
</script>
